import { Container, Grid, Typography, Button, TextField, Box } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import withServices from '../../hocs/withServices';
import Constants from '../../common/constants';
import { useAlert } from '../../hooks/useAlert';

const AchievementInfo = ({ services }) => {
    const showAlert = useAlert();
    const [achievements, setAchievements] = useState([
        {
            eventName: "",
            documentName: "",
            documentDate: "",
        }
    ]);

    const fetchAchievements = useCallback(() => {
        services.achievementInfo.getAchievements().then(({ data }) => {
            setAchievements(data);
        });
    }, [services.achievementInfo]);

    const handleInputChange = (id, field, value) => {
        setAchievements((prevState) => {
            const updatedAchievementInfo = prevState.map((achievement) =>
                achievement.id === id ? { ...achievement, [field]: value } : achievement
            );
            return updatedAchievementInfo;
        });
    };

    const renderGrid = (title, field, i) => {
        return (
            <Grid item md={9} key={i}>
                <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px", display: "flex", justifyContent: "left", alignItems: "center" }}>
                        <Typography>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        {field}
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const handleSubmit = () => {
        achievements.forEach((achievement) => {
            services.achievementInfo.saveAchievement(achievement).then(() => {
                showAlert('Ваши данные успешно отправлены!', 'success');
            })
                .finally(() => {
                    fetchAchievements();
                });
        });
    };

    useEffect(() => {
        fetchAchievements();
    }, [fetchAchievements]);


    return (
        <Container component="main" maxWidth="xl">
            <Typography variant="h5">Достижения</Typography>
            <br />

            <Grid container spacing={2} style={{ marginTop: "30px" }}>
                {Array.isArray(achievements) && achievements.map((achievement, i) => (
                    <React.Fragment key={i} style={{ marginTop: "30px" }}>
                        {renderGrid(
                            "Наименование мероприятия",
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={achievement.eventName}
                                onChange={(e) =>
                                    handleInputChange(achievement.id, "eventName", e.target.value)
                                }
                            />,
                            i
                        )}
                        {renderGrid(
                            "Наименование документа",
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={achievement.documentName}
                                onChange={(e) =>
                                    handleInputChange(achievement.id, "documentName", e.target.value)
                                }
                            />,
                            i
                        )}
                        {renderGrid(
                            "Дата выдачи документа",
                            <TextField
                                fullWidth
                                variant="outlined"
                                type="date"
                                value={achievement.documentDate}
                                onChange={(e) =>
                                    handleInputChange(achievement.id, "documentDate", e.target.value)
                                }
                            />,
                            i
                        )}
                        {renderGrid(
                            "СКАН-КОПИЯ ПОДТВЕРЖДАЮЩЕГО ДОКУМЕНТА",
                            <>
                                {
                                    achievement.document ? (
                                        <Box>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                style={{ marginRight: "20px" }}
                                                onClick={() =>
                                                    services.fileUpload.getDocument(
                                                        achievement.document.id,
                                                        achievement.document.path.split("/").pop()
                                                    )
                                                }
                                            >
                                                Скачать файл
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                component="label"
                                            >
                                                <input
                                                    type="file"
                                                    hidden
                                                    onChange={(e) => {
                                                        services.fileUpload.secretaryUploadDocument(achievement.document.id, e.target.files[0])
                                                    }}
                                                />
                                                Обновить файл
                                            </Button>
                                        </Box>
                                    ) : (
                                        <TextField
                                            label="Document File"
                                            type="file"
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => {
                                                services.fileUpload.uploadDocument(e.target.files[0], Constants.FILE_TYPES.achievementDocument, () => { })
                                                    .then((response) => {
                                                        handleInputChange(
                                                            achievement.id,
                                                            "documentId",
                                                            response.data
                                                        )
                                                    })
                                            }}
                                        />
                                    )
                                }
                            </>,
                            i
                        )}
                    </React.Fragment>
                ))}
            </Grid>
            <Button
                variant="outlined"
                color="primary"
                style={{ width: "100%", marginTop: "20px", marginBottom: "20px" }}
                onClick={() =>
                    setAchievements((prevState) => ([
                        ...(Array.isArray(prevState) ? prevState : []),
                        {
                            eventName: "",
                            documentName: "",
                            documentDate: "",
                        },
                    ]
                    ))
                }
            >
                Добавить
            </Button>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
            >
                Сохранить
            </Button>
        </Container>
    );
};

export default withServices()(AchievementInfo)